<template>
  <div>
    <div class="sayfahead tek">
      <h1>Bekleyen Dönemler</h1>
      <el-button-group class="float-right YeniBtn">
        <el-button type="info" size="small" @click="SayfaYukle()">
          Yenile
        </el-button>
        <el-button type="success" size="small" @click="DonemDetay(null)">
          Dönem Oluştur
        </el-button>
      </el-button-group>
    </div>

    <div class="icerik">
      <div class="SpotlightKutu" style="z-index: 1">
        <div class="input">
          <el-input
            :disabled="lo"
            placeholder="Bina Adı yazarak aratınız"
            v-model="search">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
      </div>
      <el-table
        v-if="DonemListe"
        :data="DonemListe.filter(data => !search || data.BinaAdi.toLowerCase().includes(search.toLowerCase()))"
        class="golgetable"
        :height="Height"
        @current-change="TableSecim">
        <el-table-column
          label="Bina Adı"
          prop="BinaAdi">
        </el-table-column>
        <el-table-column
          label="Ekleme Tarihi"
          prop="tarih"
          width="150">
        </el-table-column>
        <el-table-column
          label="Yetkili"
          prop="Yetkili"
          width="250">
        </el-table-column>
        <el-table-column
          label="Uzaktan Okuma"
          prop="ufirma"
          width="150">
        </el-table-column>
        <el-table-column
          label="Bölge"
          prop="oBolge"
          width="200">
        </el-table-column>
        <el-table-column
          label="D/F"
          width="50">
          <template slot-scope="scope">
            <b :class="scope.row.DosyaText === 'Geldi' ? 'text-success' : 'text-danger'">D</b>
            <b :class="scope.row.FaturaBilgi === 'Geldi' ? 'text-success' : 'text-danger'">F</b>
          </template>
        </el-table-column>

      </el-table>

      <Yukleniyor :data="lo"></Yukleniyor>
      <DonemModal v-if="DonemModalDurum" :Binalar="Binalar" :DonemAdi="DonemAdi" :Bina_id="Bina_id" :Taslak="Taslak"
                  :Durum="DonemModalDurum"
                  @Durum="SayfaYukle"
                  :Donem_id="Donem_id"></DonemModal>

    </div>
  </div>
</template>

<script>
import Yukleniyor from "../../../components/Doc/Yukleniyor";
import DonemModal from "./DonemModal";

export default {
  components: {DonemModal, Yukleniyor},
  data() {
    return {
      DonemModalDurum: false,
      search: null,
      lo: false,
      DonemListe: null,
      Binalar: null,
      Modal: false,
      Donem_id: null,
      Bina_id: null,
      DonemAdi: null,
      Taslak: false,
      Height: window.innerHeight - 100,
      ModalBaslik: 'Dönem Oluştur'
    }
  },
  methods: {
    TableSecim(val) {
      this.DonemDetay(val.id, val.Taslak, val.Bina_id)
    },
    DonemDetay(Donem_id, Taslak, Bina_id) {
      this.DonemModalDurum = true;
      this.Donem_id = Donem_id;
      this.Taslak = Taslak;
      this.Bina_id = Bina_id;
    },
    BinaGetir() {
      this.lo = true;
      this.$store.dispatch("Post", {path: '_enerji/donem/bina'})
        .then(response => {
          this.lo = false;
          if (response.Durum === 'OK') {
            this.Binalar = response.Liste;

          } else {
            this.$message.error(response.Mesaj);
          }
        });
    },
    SayfaYukle() {
      this.BinaGetir()
      this.DonemModalDurum = false
      this.lo = true
      this.$store.dispatch("Get", {path: '_enerji/donem'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.DonemListe = response.Liste;
            this.DonemAdi = response.DonemAdi;

            this.lo = false
          } else {
            this.$message.error(response.Mesaj);
          }
        });

    }
  },
  created() {
    this.SayfaYukle()

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/_Sayac/Donem/Index.vue